import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { useMemo } from "react";
import { Toaster } from "sonner";
import { AuthProvider } from "@/contexts/AuthContext";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import MobileFab from "@/components/MobileFab";
import Home from "@/pages/Home";
import Category from "@/pages/Category";
import Search from "@/pages/Search";
import ListingDetail from "@/pages/ListingDetail";
import ListingForm from "@/pages/ListingForm";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import AuthCallback from "@/pages/AuthCallback";
import Dashboard from "@/pages/Dashboard";
import Favorites from "@/pages/Favorites";
import Messages from "@/pages/Messages";
import PromoteSuccess from "@/pages/PromoteSuccess";
import ForgotPassword from "@/pages/ForgotPassword";
import ResetPassword from "@/pages/ResetPassword";
import "@/App.css";

function Router() {
  // Synchronously detect OAuth callback BEFORE auth context decides anything
  const location = useLocation();
  if (location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }
  return (
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/auth/callback" element={<AuthCallback />} />
      <Route path="/category/:slug" element={<Category />} />
      <Route path="/search" element={<Search />} />
      <Route path="/listing/:id" element={<ListingDetail />} />
      <Route path="/post" element={<ListingForm mode="create" />} />
      <Route path="/edit/:id" element={<ListingForm mode="edit" />} />
      <Route path="/login" element={<Login />} />
      <Route path="/register" element={<Register />} />
      <Route path="/forgot-password" element={<ForgotPassword />} />
      <Route path="/reset-password" element={<ResetPassword />} />
      <Route path="/dashboard" element={<Dashboard />} />
      <Route path="/favorites" element={<Favorites />} />
      <Route path="/messages" element={<Messages />} />
      <Route path="/messages/:otherId/:listingId" element={<Messages />} />
      <Route path="/promote/success" element={<PromoteSuccess />} />
    </Routes>
  );
}

export default function App() {
  const toastOptions = useMemo(
    () => ({ className: "font-mono-data text-xs uppercase border-2 border-black rounded-none" }),
    []
  );
  return (
    <BrowserRouter>
      <AuthProvider>
        <Header />
        <main className="min-h-[calc(100vh-200px)]">
          <Router />
        </main>
        <MobileFab />
        <Footer />
        <Toaster position="bottom-right" toastOptions={toastOptions} />
      </AuthProvider>
    </BrowserRouter>
  );
}
